/* Bloom Suche: weiche Schließ-Animation für das Such-Panel */
(function () {
  customElements.whenDefined('details-modal').then(function () {
    var DM = customElements.get('details-modal');
    if (!DM || DM.prototype.__bloomPatched) return;
    DM.prototype.__bloomPatched = true;
    var originalClose = DM.prototype.close;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animatedClose(modal, focusToggle) {
      if (!modal.isOpen() || modal._bloomClosing) return;
      if (reduce) return originalClose.call(modal, focusToggle);
      modal._bloomClosing = true;
      modal.classList.add('is-closing');
      setTimeout(function () {
        originalClose.call(modal, focusToggle);
        modal.classList.remove('is-closing');
        modal._bloomClosing = false;
      }, 420);
    }

    DM.prototype.close = function (focusToggle) {
      if (!this.classList.contains('header__search')) return originalClose.call(this, focusToggle);
      animatedClose(this, focusToggle);
    };

    // Schließen-Button und Esc sind im Theme schon gebunden – vorher abfangen
    document.querySelectorAll('details-modal.header__search').forEach(function (modal) {
      var btn = modal.querySelector('.search-modal__close-button');
      if (btn) btn.addEventListener('click', function (e) { e.stopImmediatePropagation(); animatedClose(modal, true); }, true);
      modal.querySelector('details').addEventListener('keyup', function (e) {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') { e.stopImmediatePropagation(); animatedClose(modal, true); }
      }, true);
    });
  });
})();

/* Bloom Suche: weicher Wort-Wechsel im leeren Feld („Suche nach“ + Vorschlag in Weinrot-Kursiv) */
(function () {
  var words = ['Heal Yourself', 'Love Yourself', 'E-Journals', 'Gratitude Journal', 'Selbstliebe'];
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('details-modal.header__search').forEach(function (modal) {
    var input = modal.querySelector('.search__input');
    var details = modal.querySelector('details');
    var field = input && input.closest('.field');
    if (!input || !details || !field) return;
    var base = input.getAttribute('placeholder');
    var hint = document.createElement('span');
    hint.className = 'bs-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<span class="bs-hint__lead">Suche nach</span><span class="bs-hint__word"></span>';
    field.appendChild(hint);
    var slot = hint.querySelector('.bs-hint__word');
    var timer = null, w = 0;
    function sync() { hint.classList.toggle('is-hidden', input.value.length > 0); }
    function show(word) {
      var el = document.createElement('span');
      el.className = 'bs-hint__w';
      el.textContent = word;
      var old = slot.querySelector('.bs-hint__w:not(.is-out)');
      if (old) { old.classList.add('is-out'); setTimeout(function () { old.remove(); }, 600); }
      slot.appendChild(el);
      el.getBoundingClientRect(); setTimeout(function () { el.classList.add('is-in'); }, 20);
    }
    function loop() { place(); show(words[w]); w = (w + 1) % words.length; if (!still) timer = setTimeout(loop, 2600); }
    function place() { var fr = field.getBoundingClientRect(), ir = input.getBoundingClientRect(); if (ir.width) hint.style.left = (ir.left - fr.left + 25) + 'px'; }
    function start() { stop(); w = 0; place(); input.setAttribute('placeholder', ''); field.classList.add('bs-has-hint'); sync(); timer = setTimeout(loop, 350); }
    function stop() { clearTimeout(timer); timer = null; slot.innerHTML = ''; input.setAttribute('placeholder', base); field.classList.remove('bs-has-hint'); }
    input.addEventListener('input', sync);
    new MutationObserver(function () { details.hasAttribute('open') ? start() : stop(); }).observe(details, { attributes: true, attributeFilter: ['open'] });
  });
})();
